/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

'use client';

import React, { ComponentType, ReactNode } from 'react';

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

/**
 * Cray Theme Minimal Layout Component
 * Simplified layout for cart, checkout, and other minimal pages
 */

interface MinimalLayoutProps {
  children: ReactNode;
  Header: ComponentType;
  Footer: ComponentType;
  MobileNavigation: ComponentType;
}

export const MinimalLayout: React.FC<MinimalLayoutProps> = ({ children, Header, Footer, MobileNavigation }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Header />
      <MobileNavigation />
      <main style={{ flex: 1, padding: '1rem', backgroundColor: 'white', margin: '1rem', borderRadius: '8px' }}>{children}</main>
      <Footer />
    </div>
  );
};

export default MinimalLayout;
